export default __webpack_public_path__ + "/images/blue-frost-pattern.jpg";